<template>
  <div class="ticket-details" >
    <div class="table-filters">
      <i class="n-i n-i-columns"
         @click="columnFilter = !columnFilter"
         v-click-outside-element="columnFilterConfig">
      </i>
      <div ref="column-filter">
        <ColumnSelectFilter :filter="columnFilter"
                            :id="'detail'"
                            :items="headers"
                            :selected="selectedColumns"
                            @inputFilter="setColumns"
                            @resetInputFilter="resetColumns">
        </ColumnSelectFilter>
      </div>
    </div>
    <Table :data="ticketDetails"
           :headers="headers"
           :selected="selectedColumns"
           :type="'details'">
    </Table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { map } from 'lodash';
import ClickOutsideElement from '../directives/outside-element';
import ColumnSelectFilter from './ColumnSelectFilter';
import Table from './Table';
import { bus } from '../utility';

export default {
  name: 'TicketDetails',
  components: {
    ColumnSelectFilter,
    Table,
  },
  directives: {
    ClickOutsideElement,
  },
  data() {
    return {
      headers: [
        { value: 'round' },
        { value: 'type' },
        { value: 'value', values: true },
        { value: 'totalStake' },
        { value: 'totalPayout' },
        { value: 'status', status: true },
      ],
      columnFilterConfig: {
        exclude: ['column-filter'],
        handler: 'closeFilter',
      },
      columnFilter: false,
      selectedColumns: [],
    };
  },
  computed: {
    ...mapGetters([
      'tickets',
      'ticketBets',
    ]),
    ticketDetails() {
      if (this.tickets.length) {
        return this.ticketBets;
      }
      return [];
    },
  },
  mounted() {
    this.selectedColumns = map(this.headers, () => true);
    bus.$on('restartFilters', () => {
      this.resetColumns();
    });
  },
  methods: {
    closeFilter() {
      this.columnFilter = false;
    },
    resetColumns() {
      this.columnFilter = !this.columnFilter;
      this.selectedColumns = map(this.headers, () => true);
    },
    setColumns(values) {
      this.selectedColumns = values;
    },
  },
};
</script>
<style lang="scss">
.ticket-details {
  width: 33%;
  padding-left: 20px;
  table {
    tbody > tr {
      text-align: center;
      vertical-align: middle;

      &:last-child > td {
        background: none;
        border-bottom: initial;
      }

      &:nth-last-child(2) {
        border-bottom: initial;
      }
    }
  }
}

.table-filters {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 50px;
  background-color: #d8dfe1;
  padding-right: 10px;
  .n-i {
    font-size: 16px;
    color: #808b9c;
    &:hover {
      color: $tableWhite;
      cursor: pointer;
    }
  }
  .column-filter {
    right: 0;
    margin-right: 10px;
  }
}
</style>
